import React, { useState } from 'react'
import moment from 'moment'
import { Link, withRouter } from 'react-router-dom'
import styled from 'styled-components'
import {
  TripPicture,
  ProfilePicture,
  FavoriteAction,
  ModalConfirm,
  Loader,
  OrganizationProfilePicture,
} from '@/components'
import common from '@/utils/common'
import { Button, Card, Checkbox, Form, Input, Typography } from 'antd'
import { NewTabIcon } from '@/assets/icons'
import { APIS } from '@/utils/apiEndpoints'
import { useHistory } from 'react-router-dom'
import { svgImage } from '@/assets/svg/svg-icon'
import { useSelector } from 'react-redux'

export const TripPlaceHolder = styled.div`
  display: block;
  background-color: #d1d1d1;
  width: 100%;
  height: 250px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
`
const CopyContentButton = ({ trip }) => {
  const history = useHistory()
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const onSubmit = async (values) => {
    try {
      setLoading(true)
      const payload = {
        ...values,
        tripId: trip._id,
        organizationId: trip?.organizationId,
      }
      const res = await APIS.createProject(payload)
      history.push(`/dashboard/active-events/${res.result._id}`)
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }
  const codeFormItems = () => {
    return (
      <>
        <Form.Item
          name="name"
          label="Event name"
          rules={[{ required: true, message: 'The event name is required.' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="content" label="Select content to copy">
          <Checkbox.Group
            className="copy-content-field"
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <Checkbox value="trip_page">Event page</Checkbox>
            <Checkbox value="topics">Topics</Checkbox>
            <Checkbox value="attendee_views">Attendee views</Checkbox>
            {/* <Checkbox value="resources">Resources</Checkbox> */}
            <Checkbox value="questions">Questions</Checkbox>
            <Checkbox value="budget">Budget</Checkbox>
            <Checkbox value="links">Links</Checkbox>
          </Checkbox.Group>
        </Form.Item>
      </>
    )
  }

  return (
    <div>
      <Button
        onClick={() => {
          setIsOpen(true)
        }}
        type="link"
      >
        Duplicate event
      </Button>
      <ModalConfirm
        visible={isOpen}
        loading={loading}
        formItems={codeFormItems}
        title="Duplicate event"
        okText="Create event"
        initialValues={{
          name: `${trip?.name || trip?.title}_copy`,
          content: [
            'trip_page',
            'topics',
            'attendee_views',
            // 'resources',
            'questions',
            'budget',
            'links',
          ],
        }}
        onSubmit={onSubmit}
        onCancel={() => {
          setIsOpen(false)
        }}
      />
    </div>
  )
}
export const DashboardTripCard = ({
  trip,
  type,
  showHost = false,
  setTrips,
  trips,
  isHost,
  isCompPageVis
}) => {
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const tripUrl = (id, type) => {
    switch (type) {
      case 'book':
        return `/dashboard/booking-requests/${id}`
      case 'confirmed':
        return `/dashboard/confirmed-events/${id}`
      case 'active':
        return `/dashboard/active-events/${id}`
      default:
        return `/event/${id}`
    }
  }

  const showAdminStatus = (trip) => {
    let color = 'red-color'
    if (!trip?.status) {
      trip['status'] = trip?.isPublished ? 'published' : 'unpublished'
    }
    if (
      ['published', 'draft', 'created', 'unpublished'].includes(trip?.status) ||
      trip?.isPublished
    )
      color = 'green-color'

    return (
      <span
        className={color}
        style={{
          textTransform: 'capitalize',
          fontWeight: 'bold',
        }}
      >
        {trip?.status}
      </span>
    )
  }
  const getActiveTripStatus = () => {
    switch (trip?.status) {
      case 'published':
        return trip.maxGroupSize > trip.spotsFilled ? (
          <span className="green-color">
            <b>{trip.maxGroupSize - trip.spotsFilled}</b> spots available
          </span>
        ) : (
          <span className="red-color">
            This event is <b>sold out</b>.
          </span>
        )
      case 'completed':
        return (
          <span className="green-color">
            This event is <b>completed</b>.
          </span>
        )
      case 'cancelled':
        return (
          <span className="red-color">
            This event is <b>canceled</b>.
          </span>
        )
      default:
        return (
          <>
            This event is in <b>draft</b>.
          </>
        )
    }
  }
  const getConfirmedTripStatus = () => {
    const booking = trip?.booking || {}
    if (booking?._id) {
      switch (booking?.status) {
        case 'invite-pending':
        case 'invited':
          return <span>You are invited to this event.</span>
        case 'invite-accepted':
          return <span>You RSVP’d Yes to this event.</span>
        case 'invite-declined':
          return <span>You RSVP’d No to this event.</span>
        case 'pending':
          return <span>You have an open booking request.</span>
        case 'approved':
          return <span>You are registered to attend this event.</span>
        // case 'approved-maybe':
        //   return <span>Are registered to attend this event but not sure yet.</span>
        case 'pendingPayment':
          return <span>Your booking request is being charged</span>
        case 'declined':
          return <span>Your booking request was declined.</span>
        case 'withdrawn':
          return <span>You withdrawn your request.</span>
        case 'expired':
          return <span>Your booking request expired.</span>
        case 'canceled':
          return <span>You cancelled your attendance on this event.</span>
        case 'removed':
          return <span>You were removed from this event.</span>
        default:
          return <span>You saved this event.</span>
      }
    } else {
      return <span>You saved this event.</span>
    }
  }
  const getConfirmedTripAction = () => {
    const booking = trip?.booking || {}
    switch (booking?.status) {
      case 'invite-pending':
      case 'invited':
        return (
          <a target="_blank" href={tripUrl(trip?._id)}>
            <Button
              type="link"
              block
              size="large"
              style={{ gap: '5px' }}
              className="icon-holder dashboard-button"
            >
              {trip?.isRSVPEnabled ? 'Submit RSVP' : 'View event page'}{' '}
              <NewTabIcon />
            </Button>
          </a>
        )
      case 'invite-declined':
        return (
          <a target="_blank" href={tripUrl(trip?._id)}>
            <Button
              type="link"
              style={{ gap: '5px' }}
              block
              size="large"
              className="icon-holder dashboard-button"
            >
              {trip?.isRSVPEnabled ? 'Change RSVP' : 'View event page'}{' '}
              <NewTabIcon />
            </Button>
          </a>
        )
      case 'pending':
        return (
          <a target="_blank" href={tripUrl(trip?.bookingId, 'book')}>
            <Button
              type="link"
              style={{ gap: '5px' }}
              block
              size="large"
              className="icon-holder dashboard-button"
            >
              View booking request <NewTabIcon />
            </Button>
          </a>
        )
      case 'invite-accepted':
      case 'approved':
        return (
          <a target="_blank" href={tripUrl(trip?.bookingId, 'confirmed')}>
            <Button
              type="link"
              style={{ gap: '5px' }}
              block
              size="large"
              className="icon-holder dashboard-button"
            >
              Manage booking{svgImage.arrowEventPage}
            </Button>
          </a>
        )
      case 'canceled':
        return (
          <a target="_blank" href={tripUrl(trip?._id)}>
            <Button
              type="link"
              style={{ gap: '5px' }}
              block
              size="large"
              className="icon-holder dashboard-button"
            >
              Contact Host <NewTabIcon />
            </Button>
          </a>
        )
      case 'declined':
      case 'withdrawn':
      case 'expired':
      case 'removed':
      default:
        return (
          <a target="_blank" href={tripUrl(trip?._id)}>
            <Button
              type="link"
              style={{ gap: '5px' }}
              block
              size="large"
              className="icon-holder dashboard-button"
            >
              Event Page {svgImage.arrowEventPage}
            </Button>
          </a>
        )
    }
  }
  const trip_start_date = trip?.startDate
  const trip_end_date = trip?.endDate
  const trip_title = trip.name || trip.title

  let formattedDate = moment(trip_start_date, 'YYYYMMDD').format('MMMM DD, YYYY'); // July 22, 2024
  let dayOfWeek = moment(trip_start_date, 'YYYYMMDD').format('dddd');
  let formattedDateEnd = moment(trip_end_date, 'YYYYMMDD').format('MMMM DD, YYYY');
  const { currentUser } = useSelector((state) => state.auth);

  if (formattedDate == "Invalid date") {
    formattedDate = "Unspecified date";
  }
  if (dayOfWeek == "Invalid date") {
    dayOfWeek = "";
  }
  if (formattedDateEnd == "Invalid date") {
    formattedDateEnd = "Unspecified date";
  }

  return (
    <Loader loading={loading}>
      <div className='card-container'>
        <div className='date-left-content'>
          <div className='date1'>{formattedDate}</div>
          <div className='date2'>{dayOfWeek}</div>
        </div>
        <div className="trip-card-width card-right-content" style={{ opacity: isHost && !isCompPageVis ? 0.6 : 1 }}>
          <div className='dashboardCard'>
            <div>
              {/* {showHost && (
                <div className="card-host-profile">
                  <OrganizationProfilePicture
                    organization={trip?.organization}
                    size={80}
                  />
                </div>
              )} */}
              <div className="trip-content" style={showHost ? { marginTop: '20px' } : {}}>
                <div className='event-description'>
                  <div>
                    <Typography.Title
                      level={5}
                      title={trip_title}
                      className="trip-card trip-card-title">
                      <div className='trip-card-title-container'>
                        <div className='trip-card-title-name'>{trip_title}</div>
                        {trip?.booking?.status === 'approved' && <div className='trip-card-title-status trip-card-title-status-going'>Going</div>}
                        {trip?.booking?.status === 'invite-accepted' && <div className='trip-card-title-status trip-card-title-status-maybe'>Maybe</div>}
                        {trip?.booking?.status === ('withdrawn' || 'canceled' || 'removed') && <div className='trip-card-title-status trip-card-title-status-not-going'>Not Going</div>}
                        {trip?.ownerDetails?.email === currentUser.email && <div className='trip-card-title-status trip-card-title-status-host'>Host</div>}
                      </div>
                    </Typography.Title>
                  </div>
                  <div className='card-details'>
                    <div className='card-location'>
                      <div className='text'>{trip.location ? trip.location : "Unspecified location"}</div>
                    </div>
                    <div className='card-calendar'>
                      <div className='svg'>{svgImage.calendarSvg}</div>
                      <div className='text'>{formattedDate === "Unspecified date" ?
                        formattedDate :
                        formattedDate === formattedDateEnd ?
                          formattedDate : `${formattedDate} until ${formattedDateEnd}`}</div>
                    </div>
                  </div>
                  <div className='card-host'>
                    <div className='host'>
                      <div className='org-image'><img src={trip?.organization?.avatarUrl}></img></div>
                      <div onClick={() => history.push(`/dashboard/organizations/${trip?.organization?._id}`)} className='host-name'>{trip?.organization?.name || '???'}</div>
                    </div>
                  </div>
                </div>
                <div className="status-line">
                  {type === 'active' && (
                    <>
                      <Button
                        block
                        size="large"
                        type="primary"
                        className="margin-top-10 dashboard-button"
                        onClick={() => {
                          history.push(tripUrl(trip._id, type))
                        }}
                      >
                        Manage Event {svgImage.arrowEventPage}
                      </Button>
                    </>
                  )}
                  {type === 'book' && (
                    <>
                      {/* <Typography.Text>
                        Your booking request is <b>{trip.status}</b>.
                      </Typography.Text>
                      <Typography.Text>
                        <div>
                          Expires on{' '}
                          <b>{common.tripRequestExpireOn(trip.createdAt)}</b>.
                        </div>
                      </Typography.Text> */}
                      <Button
                        type="primary"
                        size="large"
                        className="margin-top-10 dashboard-button"
                        block
                        onClick={() => {
                          history.push(`/event/${trip._id}`)
                        }}
                      >
                        View Event {svgImage.arrowEventPage}
                      </Button>
                    </>
                  )}
                  {type === 'confirmed' && (
                    <>
                      <div>{getConfirmedTripAction()}</div>
                    </>
                  )}
                  {type === 'admin' && (
                    <>
                      {showAdminStatus(trip)}
                      <CopyContentButton trip={trip} />
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="imageContainer">
              <div className="favorite-action-overlay">
                {type == 'confirmed' && (
                  <FavoriteAction
                    trip={trip}
                    setTrips={setTrips}
                    setLoading={setLoading}
                    trips={trips}
                  />
                )}
              </div>
              <img src={(trip?.pictureUrls && trip.pictureUrls.length > 0) ? trip.pictureUrls[0] : svgImage.imageNotFound404}></img>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  )
}
